export class Zona {

    public intId?:number;
    public strNombre?:string;
    public intTarifaTipo?:number;

}
